module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_04.e6855911.jpg";